import { Dispatch } from 'redux';
import { axiosInstance, request, requestConfig } from './base';
import {
  RegistroStatus,
  GETConciliacaoAtivoResponse,
  ContaDepositoResponse,
  PagamentoResponse,
  PagamentoSolicitarLiquidacaoRequest,
  PagamentoSolicitarLiquidacaoEmLoteRequest,
  PagamentoExtraordinarioRequest,
  SolicitarLiquidacaoRequest,
  InstrumentoFinanceiroApiResponse,
  ConciliacaoArquivoResponse,
  PaginatedResult,
  GETInstrumentosFilterParams,
  RascunhoFilter,
  RascunhoFilterResponse,
  RascunhoRequest,
  InstrumentoFinanceiro,
  RascunhoDocumentRequest,
  RascunhoUpdateResponse,
  CalcularAmortizacaoRequest,
  CalcularAmortizacaoResponse,
  POSTEventosFinanceirosFilterParams,
  CadastroInstrumentoFinanceiroApiRequest,
  CommandResultTyped,
  FluxoMonitorResult,
  PagamentoDocuments,
  GarantiasResponse,
  InvestidorCertidaoResponse,
  RascunhoIdAndCod,
  DownloadResponse,
  TipoLiquidacao,
  OperacaoOfertaPrimariaResponse,
  ReservarUltimoNumeroDaEmissaoRequest,
  AnbimaFundoResponse,
  InstrumentosFinanceirosFilter,
} from 'common/genericTypes';
import { Moment } from 'moment';
import { errorMessages } from 'common/errorMessages.strings';

export const GETInstrumentoDetalhes = async (
  dispatch: Dispatch,
  id: string,
  stackRequest: boolean = false
): Promise<InstrumentoFinanceiroApiResponse> => {
  return await request(
    () =>
      axiosInstance.get<InstrumentoFinanceiroApiResponse>(`${requestConfig.api}api/v1/instrumentos-financeiros/${id}`),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETInstrumentoDetalhesByCodigo = async (
  dispatch: Dispatch,
  codigoInstrumento: string,
  stackRequest: boolean = false
): Promise<InstrumentoFinanceiroApiResponse> => {
  return await request(
    () =>
      axiosInstance.get<InstrumentoFinanceiroApiResponse>(
        `${requestConfig.api}api/v1/instrumentos-financeiros/codigos/${codigoInstrumento}`
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETInstrumentos = async (
  dispatch: Dispatch,
  params?: GETInstrumentosFilterParams,
  stackRequest: boolean = false
): Promise<Array<InstrumentoFinanceiroApiResponse>> => {
  return await request(
    () =>
      axiosInstance.get<Array<InstrumentoFinanceiroApiResponse>>(
        `${requestConfig.api}api/v1/instrumentos-financeiros`,
        params ? { params } : undefined
      ),
    dispatch,
    undefined,
    stackRequest
  );
};
export const GETInstrumentosResume = async (
  dispatch: Dispatch,
  params?: GETInstrumentosFilterParams,
  stackRequest: boolean = false
): Promise<Array<InstrumentoFinanceiroApiResponse>> => {
  return await request(
    () =>
      axiosInstance.get<Array<InstrumentoFinanceiroApiResponse>>(
        `${requestConfig.api}api/v1/instrumentos-financeiros/resume`,
        params ? { params } : undefined
      ),
    dispatch,
    undefined,
    stackRequest
  );
};
export const GETInstrumentosEventoExtraordinarioResume = async (
  dispatch: Dispatch,
  params?: GETInstrumentosFilterParams,
  stackRequest: boolean = false
): Promise<Array<InstrumentoFinanceiroApiResponse>> => {
  return await request(
    () =>
      axiosInstance.get<Array<InstrumentoFinanceiroApiResponse>>(
        `${requestConfig.api}api/v1/instrumentos-financeiros/evento-extraordinario/resume`,
        params ? { params } : undefined
      ),
    dispatch,
    undefined,
    stackRequest
  );
};
export const GETInstrumentosOfertaPrimariaResume = async (
  dispatch: Dispatch,
  params?: GETInstrumentosFilterParams,
  stackRequest: boolean = false
): Promise<Array<InstrumentoFinanceiroApiResponse>> => {
  return await request(
    () =>
      axiosInstance.get<Array<InstrumentoFinanceiroApiResponse>>(
        `${requestConfig.api}api/v1/instrumentos-financeiros/oferta-primaria/resume`,
        params ? { params } : undefined
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETGarantiasInstrumento = async (
  dispatch: Dispatch,
  stackRequest: boolean = false
): Promise<GarantiasResponse> => {
  return await request(
    () => axiosInstance.get<GarantiasResponse>(`${requestConfig.api}api/v1/garantia`),
    dispatch,
    undefined,
    stackRequest
  );
};
export const GETInstrumentosPaginated = async (
  dispatch: Dispatch,
  params?: GETInstrumentosFilterParams,
  stackRequest: boolean = false
): Promise<PaginatedResult<InstrumentoFinanceiroApiResponse>> => {
  return await request(
    () =>
      axiosInstance.get<PaginatedResult<InstrumentoFinanceiroApiResponse>>(
        `${requestConfig.api}api/v1/instrumentos-financeiros/paginated`,
        params ? { params } : undefined
      ),
    dispatch,
    undefined,
    stackRequest
  );
};
export const POSTInstrumentosPaginated = async (
  dispatch: Dispatch,
  filter?: GETInstrumentosFilterParams,
  stackRequest: boolean = false,
  emissorId?: string | null,
  custodianteId?: string | null,
  coordenadorId?: string | null,
  agenteFiduciarioId?: string | null,
  escrituradorId?: string | null,
  administradorFiduciarioId?: string | null
): Promise<PaginatedResult<InstrumentoFinanceiroApiResponse>> => {
  return await request(
    () =>
      axiosInstance.post<PaginatedResult<InstrumentoFinanceiroApiResponse>>(
        `${requestConfig.api}api/v1/instrumentos-financeiros/paginated`,
        filter,
        { params: { emissorId, custodianteId, coordenadorId, agenteFiduciarioId, escrituradorId, administradorFiduciarioId } }
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTInstrumentosSaldosAtivosPaginated = async (
  dispatch: Dispatch,
  filter?: GETInstrumentosFilterParams,
  stackRequest: boolean = false,
  emissorId?: string | null,
  custodianteId?: string | null,
  coordenadorId?: string | null,
  agenteFiduciarioId?: string | null,
  escrituradorId?: string | null,
  administradorFiduciarioId?: string | null
): Promise<PaginatedResult<InstrumentoFinanceiroApiResponse>> => {
  return await request(
    () =>
      axiosInstance.post<PaginatedResult<InstrumentoFinanceiroApiResponse>>(
        `${requestConfig.api}api/v1/instrumentos-financeiros/saldos-ativos`,
        filter,
        { params: { emissorId, custodianteId, coordenadorId, agenteFiduciarioId, escrituradorId, administradorFiduciarioId } }
      ),
    dispatch,
    undefined,
    stackRequest
  );
};
export const POSTEventosFinanceirosPaginated = async (
  dispatch: Dispatch,
  filter?: POSTEventosFinanceirosFilterParams,
  stackRequest: boolean = false
): Promise<PaginatedResult<PagamentoResponse>> => {
  return await request(
    () =>
      axiosInstance.post<PaginatedResult<PagamentoResponse>>(
        `${requestConfig.api}api/v1/instrumentos-financeiros/pagamentos/paginated`,
        filter
      ),
    dispatch,
    undefined,
    stackRequest
  );
};
export const POSTValidateInstrumento = async (
  dispatch: Dispatch,
  status: RegistroStatus,
  id: string,
  justificativa?: string,
  attachments?: File[],
  stackRequest: boolean = false
) => {
  const formData = new FormData();
  attachments?.forEach((attachment) => {
    formData.append('anexos', attachment);
  });
  const anexos = attachments && formData;

  const validationEndpoints: { [key: string]: string } = {
    [RegistroStatus.Aprovado]: `${requestConfig.api}api/v1/instrumentos-financeiros/${id}/approve`,
    [RegistroStatus.AguardandoCorrecao]: `${requestConfig.api}api/v1/instrumentos-financeiros/${id}/reject-pendencies`,
    [RegistroStatus.Reprovado]: `${requestConfig.api}api/v1/instrumentos-financeiros/${id}/reject`,
  };

  const currentEndpoint = validationEndpoints[status];
  return await request(
    () =>
      axiosInstance.post(currentEndpoint, anexos, {
        params: {
          justificativa,
        },
        headers: { 'Content-Type': 'multipart/form-data' },
      }),
    dispatch,
    errorMessages.validation.instrumentoFinanceiro.generic(status),
    stackRequest
  );
};

export const GETInstrumentoDocumentDownloadUrl = async (
  dispatch: Dispatch,
  documentId: string,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.get<string>(`${requestConfig.api}api/v1/instrumentos-financeiros/document/${documentId}/download`),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTSuspenderInstrumento = async (
  dispatch: Dispatch,
  instrumentoId: string,
  justificativa: string,
  anexosList: File[],
  stackRequest: boolean = false
) => {
  const formData = new FormData();
  anexosList.forEach((anexo) => {
    formData.append('anexos', anexo);
  });

  const anexos = anexosList && formData;

  return await request(
    () =>
      axiosInstance.post<InstrumentoFinanceiroApiResponse>(
        `${requestConfig.api}api/v1/instrumentos-financeiros/${instrumentoId}/suspend`,
        anexos,
        {
          params: {
            justificativa,
          },
          headers: { 'Content-Type': 'multipart/form-data' },
        }
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTLiberarInstrumento = async (
  dispatch: Dispatch,
  instrumentoId: string,
  justificativa: string,
  anexosList: File[],
  stackRequest: boolean = false
) => {
  const formData = new FormData();
  anexosList.forEach((anexo) => {
    formData.append('anexos', anexo);
  });

  const anexos = anexosList && formData;

  return await request(
    () =>
      axiosInstance.post<InstrumentoFinanceiroApiResponse>(
        `${requestConfig.api}api/v1/instrumentos-financeiros/${instrumentoId}/unsuspend`,
        anexos,
        {
          params: {
            justificativa,
          },
          headers: { 'Content-Type': 'multipart/form-data' },
        }
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTEnviarLiquidacao = async (
  dispatch: Dispatch,
  instrumentoId: string,
  solicitarLiquidacaoRequest: SolicitarLiquidacaoRequest,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.post<InstrumentoFinanceiroApiResponse>(
        `${requestConfig.api}api/v1/instrumentos-financeiros/${instrumentoId}/enviar-liquidacao`,
        solicitarLiquidacaoRequest
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETContasDeposito = async (dispatch: Dispatch, stackRequest: boolean = false) => {
  return await request(
    () =>
      axiosInstance.get<Array<ContaDepositoResponse>>(
        `${requestConfig.api}api/v1/instrumentos-financeiros/contas-deposito`
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export interface POSTContasDepositoPaginatedFilter {
  page: number;
  pageSize: number;
  instrumentosFinanceirosFilter?: Array<InstrumentosFinanceirosFilter>;
}

export const POSTContasDepositoPaginated = async (
  dispatch: Dispatch,
  filter: POSTContasDepositoPaginatedFilter,
  stackRequest: boolean = false
): Promise<PaginatedResult<ContaDepositoResponse>> => {
  return await request(
    () =>
      axiosInstance.post<PaginatedResult<ContaDepositoResponse>>(
        `${requestConfig.api}api/v1/instrumentos-financeiros/contas-deposito/paginated`,
        filter
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETConciliacaoDownload = async (
  dispatch: Dispatch,
  conciliacaoArquivoId: string,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.get<any>(
        `${requestConfig.api}api/v1/instrumentos-financeiros/conciliacao/${conciliacaoArquivoId}/download`,
        {
          responseType: 'arraybuffer',
          headers: {
            'Content-Type': 'gzip, deflate, br',
            Accept: '*/*',
          },
        }
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTConfirmarConciliacao = async (
  dispatch: Dispatch,
  conciliacaoArquivoId: string,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.post(
        `${requestConfig.api}api/v1/instrumentos-financeiros/conciliacao/${conciliacaoArquivoId}/confirmar`
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETPagamentos = async (
  dispatch: Dispatch,
  stackRequest: boolean = false
): Promise<Array<PagamentoResponse>> => {
  return await request(
    () => axiosInstance.get<Array<PagamentoResponse>>(`${requestConfig.api}api/v1/instrumentos-financeiros/pagamentos`),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETPagamento = async (
  dispatch: Dispatch,
  pagamentoId: string,
  stackRequest: boolean = false
): Promise<PagamentoResponse> => {
  return await request(
    () =>
      axiosInstance.get<PagamentoResponse>(
        `${requestConfig.api}api/v1/instrumentos-financeiros/pagamentos/${pagamentoId}`
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETPagamentoDocuments = async (
  dispatch: Dispatch,
  pagamentoId: string,
  stackRequest: boolean = false
): Promise<Array<PagamentoDocuments>> => {
  return await request(
    () =>
      axiosInstance.get<Array<PagamentoDocuments>>(
        `${requestConfig.api}api/v1/instrumentos-financeiros/pagamentos/${pagamentoId}/documentos`
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export interface UploadDocumentosLoteResponseItem {
  pagamentoId: string;
  documentoId: string;
  fileName: string;
  global: boolean;
  sucesso: boolean;
  mensagemErro: string | null;
}

export interface UploadDocumentosLoteResponse {
  documentosVinculados: UploadDocumentosLoteResponseItem[];
}

export const POSTUploadPagamentoDocumento = async (
  dispatch: Dispatch,
  pagamentoId: string,
  arquivo: File,
  stackRequest: boolean = false
): Promise<PagamentoDocuments> => {
  const formData = new FormData();
  formData.append('Documentos[0].PagamentoId', pagamentoId);
  formData.append('Documentos[0].Arquivo', arquivo);

  const response = await request(
    () =>
      axiosInstance.post<UploadDocumentosLoteResponse>(
        `${requestConfig.api}api/v1/instrumentos-financeiros/pagamentos/documentos`,
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
        }
      ),
    dispatch,
    undefined,
    stackRequest
  );

  const vinculado = response.documentosVinculados?.[0];
  return {
    id: vinculado?.documentoId ? Number(vinculado.documentoId) : 0,
    address: '',
    fileName: vinculado?.fileName ?? arquivo.name,
    extension: arquivo.name.split('.').pop() ?? '',
    size: arquivo.size,
    creationDate: new Date(),
    url: '',
  } as PagamentoDocuments;
};

export const POSTPagamentoExtraordinario = async (
  dispatch: Dispatch,
  instrumentoId: string,
  pagamentoExtraordinarioRequest: PagamentoExtraordinarioRequest,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.post<PagamentoResponse>(
        `${requestConfig.api}api/v1/instrumentos-financeiros/${instrumentoId}/pagamentos`,
        pagamentoExtraordinarioRequest
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTAprovarPagamento = async (dispatch: Dispatch, pagamentoId: string, tipoLiquidacao: TipoLiquidacao, stackRequest: boolean = false) => {
  return await request(
    () =>
      axiosInstance.post<PagamentoResponse>(
        `${requestConfig.api}api/v1/instrumentos-financeiros/pagamentos/${pagamentoId}/aprovar-liquidacao`,
        { tipoLiquidacao },
        { headers: { 'Content-Type': 'application/json' } }
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTReprovarPagamento = async (dispatch: Dispatch, pagamentoId: string, motivoReprovacao?: string, stackRequest: boolean = false) => {
  return await request(
    () =>
      axiosInstance.post<PagamentoResponse>(
        `${requestConfig.api}api/v1/instrumentos-financeiros/pagamentos/${pagamentoId}/reprovar-liquidacao`,
        motivoReprovacao ? { motivoReprovacao } : undefined
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTSolicitarLiquidacaoPagamento = async (
  dispatch: Dispatch,
  pagamentoId: string,
  pagamentoSolicitarLiquidacaoRequest: PagamentoSolicitarLiquidacaoRequest,
  attachments?: File[],
  stackRequest: boolean = false
) => {
  const formData = new FormData();
  attachments?.forEach((attachment) => {
    formData.append('anexos', attachment);
  });
  formData.append('request', JSON.stringify(pagamentoSolicitarLiquidacaoRequest));
  const requestData = formData;

  return await request(
    () =>
      axiosInstance.post(
        `${requestConfig.api}api/v1/instrumentos-financeiros/pagamentos/${pagamentoId}/solicitar-liquidacao`,
        requestData,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
        }
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTConfirmarLiquidacaoPagamento = async (
  dispatch: Dispatch,
  pagamentoId: string,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.post(
        `${requestConfig.api}api/v1/instrumentos-financeiros/pagamentos/${pagamentoId}/confirmar-liquidacao`
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

/**
 * Cancelamento da própria solicitação pelo participante que a lançou, previsto no CA09.
 * Diferente de POSTCancelarLiquidacaoPagamento, que é exclusivo de Operações e desfaz
 * liquidação: aqui a solicitação reprovada nunca liquidou, então só muda de status.
 */
export const POSTCancelarSolicitacaoEvento = async (
  dispatch: Dispatch,
  pagamentoId: string,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.post<PagamentoResponse>(
        `${requestConfig.api}api/v1/instrumentos-financeiros/pagamentos/${pagamentoId}/cancelar-solicitacao`
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTCancelarLiquidacaoPagamento = async (
  dispatch: Dispatch,
  pagamentoId: string,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.post(
        `${requestConfig.api}api/v1/instrumentos-financeiros/pagamentos/${pagamentoId}/cancelar-liquidacao`
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTContestarLiquidacaoPagamento = async (
  dispatch: Dispatch,
  pagamentoId: string,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.put(
        `${requestConfig.api}api/v1/instrumentos-financeiros/pagamentos/${pagamentoId}/contestar-liquidacao`
      ),
    dispatch,
    undefined,
    stackRequest
  );
};


export const POSTSolicitarAprovarConfirmarLiquidacaoPagamento = async (
  dispatch: Dispatch,
  pagamentoId: string,
  pagamentoSolicitarLiquidacaoRequest: PagamentoSolicitarLiquidacaoRequest,
  attachments?: File[],
  stackRequest: boolean = false
) => {
  const formData = new FormData();
  attachments?.forEach((attachment) => {
    formData.append('anexos', attachment);
  });
  formData.append('request', JSON.stringify(pagamentoSolicitarLiquidacaoRequest));
  const requestData = formData;

  return await request(
    () =>
      axiosInstance.post(
        `${requestConfig.api}api/v1/instrumentos-financeiros/pagamentos/${pagamentoId}/solicitar-aprovar-confirmar-liquidacao`,
        requestData,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
        }
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export interface SolicitarAprovarConfirmarLiquidacaoEmLoteRequest {
  itens: Array<{
    pagamentoId: string;
    instrumentoCodigo: string;
    tipoPagamento: string;
    valorPagamento: number;
    valorMora: number;
    valorMulta: number;
    liquidacaoDireta: boolean;
  }>;
}

export const POSTSolicitarAprovarConfirmarLiquidacaoEmLote = async (
  dispatch: Dispatch,
  requestBody: SolicitarAprovarConfirmarLiquidacaoEmLoteRequest,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.post(
        `${requestConfig.api}api/v1/instrumentos-financeiros/pagamentos/solicitar-aprovar-confirmar-liquidacao-lote`,
        requestBody
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTDocumentosLiquidacao = async (
  dispatch: Dispatch,
  formData: FormData,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.post(
        `${requestConfig.api}api/v1/instrumentos-financeiros/pagamentos/documentos`,
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
        }
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETCalcularAmortizacao = async (
  dispatch: Dispatch,
  calcularAmortizacaoRequest: CalcularAmortizacaoRequest,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.get<CalcularAmortizacaoResponse>(
        `${requestConfig.api}api/v1/instrumentos-financeiros/pagamentos/calcular-amortizacao`,
        {
          params: calcularAmortizacaoRequest,
        }
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETInvestidores = async (
  dispatch: Dispatch,
  instrumentoFinanceiroId: string,
  stackRequest: boolean = false
): Promise<Array<InvestidorCertidaoResponse>> => {
  return await request(
    () =>
      axiosInstance.get<Array<InvestidorCertidaoResponse>>(
        `${requestConfig.api}api/v1/instrumentos-financeiros/${instrumentoFinanceiroId}/investidores`
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETConciliacoesLista = async (dispatch: Dispatch, stackRequest: boolean = false) => {
  return await request(
    () =>
      axiosInstance.get<ConciliacaoArquivoResponse[]>(
        `${requestConfig.api}api/v1/instrumentos-financeiros/conciliacoes/listar`
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETConciliacoesAtivos = async (dispatch: Dispatch, date: Moment, stackRequest: boolean = false) => {
  return await request(
    () =>
      axiosInstance.get<Array<GETConciliacaoAtivoResponse>>(
        `${requestConfig.api}api/v1/instrumentos-financeiros/conciliacoes`,
        {
          params: { date: date.toISOString() },
        }
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const DELETEInstrumento = async (
  dispatch: Dispatch,
  instrumentoFinanceiroId: string,
  justificativa: string,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.delete(`${requestConfig.api}api/v1/instrumentos-financeiros/${instrumentoFinanceiroId}`, {
        params: { justificativa },
      }),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTGerarRascunho = async (
  dispatch: Dispatch,
  instrumentoFinanceiroId: string,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.post<string>(
        `${requestConfig.api}api/v1/instrumentos-financeiros-rascunhos/${instrumentoFinanceiroId}/clone`
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETRascunhos = async (dispatch: Dispatch, stackRequest: boolean = false) => {
  return await request(
    () =>
      axiosInstance.get<Array<InstrumentoFinanceiroApiResponse>>(
        `${requestConfig.api}api/v1/instrumentos-financeiros-rascunhos`
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETRascunhosByFilter = async (
  dispatch: Dispatch,
  filter: RascunhoFilter,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.get<RascunhoFilterResponse>(
        `${requestConfig.api}api/v1/instrumentos-financeiros-rascunhos/paginated`,
        { params: filter }
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export async function GETRascunhoByDraftId<T extends unknown>(
  dispatch: Dispatch,
  draftId: string,
  stackRequest: boolean = false
) {
  return await request(
    () => axiosInstance.get<T>(`${requestConfig.api}api/v1/instrumentos-financeiros-rascunhos/${draftId}/more-details`),
    dispatch,
    undefined,
    stackRequest
  );
}

export const POSTRascunho = async (
  dispatch: Dispatch,
  tipo: InstrumentoFinanceiro,
  rascunho: RascunhoRequest,
  documents: Array<RascunhoDocumentRequest> = [],
  stackRequest: boolean = false
) => {
  let body = new FormData();
  body.append('request', JSON.stringify(rascunho));
  if (documents.length > 0) {
    documents.forEach((document, index) => {
      body.append(`attachments[${index}].file`, document.file);
      body.append(`attachments[${index}].emissionType`, document.emissionType);
    });
  }

  return await request(
    () =>
      axiosInstance.post<RascunhoIdAndCod>(
        `${requestConfig.api}api/v1/instrumentos-financeiros-rascunhos/${tipo}`,
        body,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const PUTRascunho = async (
  dispatch: Dispatch,
  tipo: InstrumentoFinanceiro,
  rascunhoId: string,
  rascunho: RascunhoRequest,
  documents: Array<RascunhoDocumentRequest> = [],
  stackRequest: boolean = false
) => {
  let body = new FormData();
  body.append('request', JSON.stringify(rascunho));
  if (documents.length > 0) {
    documents.forEach((document, index) => {
      body.append(`attachments[${index}].file`, document.file);
      body.append(`attachments[${index}].emissionType`, document.emissionType);
    });
  }

  return await request(
    () =>
      axiosInstance.put<RascunhoIdAndCod>(
        `${requestConfig.api}api/v1/instrumentos-financeiros-rascunhos/${tipo}/${rascunhoId}`,
        body,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTRelatorioCompletoDownload = async (
  dispatch: Dispatch,
  filter?: GETInstrumentosFilterParams,
  stackRequest: boolean = false,
  timeoutMs?: number
) => {
  return await request(
    () =>
      axiosInstance.post<any>(`${requestConfig.api}api/v1/instrumentos-financeiros/relatorio-completo`, filter, {
        headers: {
          'Content-Type': 'gzip, deflate, br',
          Accept: '*/*',
        },
        responseType: 'arraybuffer',
        timeout: timeoutMs
      }),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTEventosFinaceirosCSV = async (
  dispatch: Dispatch,
  filter?: POSTEventosFinanceirosFilterParams,
  stackRequest: boolean = false
) => {
  let url = `${requestConfig.api}api/v1/instrumentos-financeiros/pagamentos/export`;

  if (filter && filter.britech) {
    url += '?britech=true';
  }

  const headers = filter && filter.britech
    ? { 'Content-Type': 'gzip, deflate, br', Accept: '*/*' }
    : { 'Content-Type': 'application/json', Accept: '*/*' };

  return await request(
    () =>
      axiosInstance.post<any>(url, filter, {
        responseType: 'arraybuffer',
        headers,
      }),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTGerarFluxoMonitor = async (
  dispatch: Dispatch,
  tipo: string,
  instrumento: CadastroInstrumentoFinanceiroApiRequest,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.post<CommandResultTyped<Array<FluxoMonitorResult>>>(
        `${requestConfig.api}api/v1/instrumentos-financeiros/monitor/fluxo/${tipo}`,
        instrumento
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETTermoEncerramento = async (
  dispatch: Dispatch,
  instrumentoId: string,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.get<string>(
        `${requestConfig.api}api/v1/instrumentos-financeiros/${instrumentoId}/termo-encerramento`
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GetNumeroEmissoes = async (
  dispatch: Dispatch,
  emissorCnpj: string,
  tipoInstrumento: InstrumentoFinanceiro,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.get<string>(
        `${requestConfig.api}api/v1/instrumentos-financeiros/numero-emissao/${emissorCnpj}?tipoInstrumento=${tipoInstrumento}`
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTReservarUltimoNumeroDaEmissao = async (
  dispatch: Dispatch,
  reservarUltimoNumeroDaEmissaoRequest: ReservarUltimoNumeroDaEmissaoRequest,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.post<any>(
        `${requestConfig.api}api/v1/instrumentos-financeiros/numero-emissao/reservar`,
        { ...reservarUltimoNumeroDaEmissaoRequest, origemReserva: 'IMF_FRONT' }
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTAprovarEdicaoInstrumento = async (
  dispatch: Dispatch,
  instrumentoFinanceiroId: string,
  edicaoId: string,
  stackRequest: boolean = false
) => {

  return await request(
    () =>
      axiosInstance.post<InstrumentoFinanceiroApiResponse>(
        `${requestConfig.api}api/v1/instrumentos-financeiros/${instrumentoFinanceiroId}/approve-edit/${edicaoId}`
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTRejeitarEdicaoInstrumento = async (
  dispatch: Dispatch,
  instrumentoFinanceiroId: string,
  edicaoId: string,
  stackRequest: boolean = false
) => {
  const formData = new FormData();

  return await request(
    () =>
      axiosInstance.post<InstrumentoFinanceiroApiResponse>(
        `${requestConfig.api}api/v1/instrumentos-financeiros/${instrumentoFinanceiroId}/reject-edit/${edicaoId}`,
        formData
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTLancamentoPU = async (
  dispatch: Dispatch,
  instrumentoGuid: string,
  pu: number,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.post<any>(
        `${requestConfig.api}api/v1/instrumentos-financeiros/${instrumentoGuid}/lancamentos-pu`,
        { pu }
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTUploadCertidaoAtivos = async (dispatch: Dispatch, param: string, stackRequest: boolean = false) => {
  try {
    const response = await request(
      () => axiosInstance.post<DownloadResponse>(`${requestConfig.api}api/v1/certidoes/ativos/${param}/download`),
      dispatch,
      undefined,
      stackRequest
    );

    downloadPDF(response.url);
  } catch (error) {
    console.error('Erro ao gerar e baixar PDFs:', error);
  }
};

const downloadPDF = async (url: string) => {
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error('Erro ao buscar o arquivo PDF');
    }

    const blob = await response.blob();

    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = downloadUrl;

    link.download = 'documento.pdf';
    document.body.appendChild(link);
    link.click();

    window.URL.revokeObjectURL(downloadUrl);
    document.body.removeChild(link);
  } catch (error) {
    console.error('Erro ao baixar o PDF:', error);
  }
};

export const GETConsultarFundoAnbimaPorCnpj = async (
  dispatch: Dispatch,
  cnpj: string,
  stackRequest: boolean = false
): Promise<AnbimaFundoResponse> => {
  return await request(
    () =>
      axiosInstance.get<AnbimaFundoResponse>(
        `${requestConfig.api}api/v1/cotas-de-fundo/anbima/consultar-cnpj/${cnpj}`
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTImportarMinuta = async (
  dispatch: Dispatch,
  file: File,
  stackRequest: boolean = false
) => {
  const formData = new FormData();
  formData.append('file', file);

  return await request(
    () =>
      axiosInstance.post<any>(
        `${requestConfig.api}api/v1/instrumentos-financeiros/desminutador`,
        formData,
        {
        headers: { 'Content-Type': 'multipart/form-data' },
          timeout: 600000
        }
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const PUTRevisarPUAgenteFiduciario = async (
  dispatch: Dispatch,
  payload: { pagamentoId: string, puRevisado: number, percentual: number, liquidacaoDireta: boolean },
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.put<any>(
        `${requestConfig.api}api/v1/instrumentos-financeiros/pagamentos/agente-fiduciario/revisar-pu`,
        payload
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTSolicitarAprovacaoAF = async (
  dispatch: Dispatch,
  pagamentoId: string,
  payload: { puEmissor?: number; aceitouPUProjetado: boolean },
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.post(
        `${requestConfig.api}api/v1/instrumentos-financeiros/pagamentos/${pagamentoId}/solicitar-aprovacao-af`,
        payload
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTAprovarPUAF = async (
  dispatch: Dispatch,
  pagamentoId: string,
  payload: { aceitouPUEmissor: boolean },
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.post(
        `${requestConfig.api}api/v1/instrumentos-financeiros/pagamentos/${pagamentoId}/aprovar-pu-af`,
        payload
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTReprovarPUAF = async (
  dispatch: Dispatch,
  pagamentoId: string,
  payload: { puAgenteFiduciario: number },
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.post(
        `${requestConfig.api}api/v1/instrumentos-financeiros/pagamentos/${pagamentoId}/reprovar-pu-af`,
        payload
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export interface LiquidacaoEmLoteConsultaRequest {
  instrumentos: Array<{
    codigo: string;
    tipo: string;
    dataVencimento: string;
  }>;
}

export interface LiquidacaoEmLoteConsultaSucessoItem {
  id: string;
  codigo: string;
  tipo: string;
  tipoInstrumentoFinanceiro: string;
  puAtualizado: number;
  puMulta: number;
  puMora: number;
  dataVencimento: string;
}

export interface LiquidacaoEmLoteConsultaErroItem {
  codigo: string;
  tipo: string;
  dataVencimento: string;
  erro: string;
}

export interface LiquidacaoEmLoteConsultaResponse {
  sucessos: LiquidacaoEmLoteConsultaSucessoItem[];
  erros: LiquidacaoEmLoteConsultaErroItem[];
}

export const POSTConsultarLiquidacaoEmLote = async (
  dispatch: Dispatch,
  requestBody: LiquidacaoEmLoteConsultaRequest,
  stackRequest: boolean = false
): Promise<LiquidacaoEmLoteConsultaResponse> => {
  return await request(
    () =>
      axiosInstance.post<LiquidacaoEmLoteConsultaResponse>(
        `${requestConfig.api}api/v1/instrumentos-financeiros/pagamentos/consultar-liquidacao-lote`,
        requestBody
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETModeloLiquidacaoEmLote = async (
  dispatch: Dispatch,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.get(
        `${requestConfig.api}api/v1/instrumentos-financeiros/pagamentos/modelo-liquidacao-lote`,
        {
          responseType: 'blob',
        }
      ),
    dispatch,
    undefined,
    stackRequest
  );
};
